module.exports = {
  "/": {
    "name": "index",
    "success": {
      "index page loaded": [
        "INDEX_LOAD"
      ]
    },
    "partialSuccess": {
      "access denied": [
        "ACCESS_DENIED"
      ]
    }
  },
  "/ticket/*": {
    "name": "ticket",
    "success": {
      "ticket loaded": [
        "TICKET_LOAD"
      ]
    }
  },
  "/:slug": {
    "name": "slug",
    "success": {
      "index page loaded": [
        "INDEX_LOAD"
      ]
    },
    "partialSuccess": {
      "access denied": [
        "ACCESS_DENIED"
      ]
    }
  }
};